import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";
import { HouseholdClaimProductCode } from "src/containers/household-claim/models/claim-product-code";
import { HouseholdClaimCoverage } from "src/containers/household-claim/models/household-claim-coverage";

export class HouseholdClaimDecisionTreeModel extends BaseModel {
    @Expose() address = "";
    @Expose() policyId = 0;
    @Expose() policyNumber = 0;
    @Expose() productCode: HouseholdClaimProductCode | null = null;
    @Expose()
    @Type(() => HouseholdClaimCoverage)
    coverages: HouseholdClaimCoverage[] = [];
}
